import React, { useEffect, useState } from "react";
import TableView from "../../components/TableView";
import { Avatar, Typography, Box, Snackbar, Alert, CircularProgress } from "@mui/material";
import { UserApiService } from "../../services/api/UserAPIService";
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE } from "../../shared/constants";

export default function UserListing() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [snackData, setSnackData] = useState({
    show: false,
    message: "",
    type: "error",
  });

  useEffect(() => {
    fetchUserDetails();
  }, []);

  const fetchUserDetails = (page = 1, pageSize = 100) => {
    setLoading(true);
    UserApiService.userListing(page, pageSize)
      .then((response) => {
        setSnackData({
          show: true,
          message: response.message || API_SUCCESS_MESSAGE.USER_DETAILS,
          type: "success",
        });
        setData(response);
        setPage(page);
        setPageSize(pageSize);
      })
      .catch((errResponse) => {
        setSnackData({
          show: true,
          message:
            errResponse?.response?.data?.message ||
            API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR,
          type: "error",
        });
      })
      .finally(() => setLoading(false));
  };

  return (
    <>
      <Box display="flex" alignItems="center" gap={2} p={2}>
        <Avatar sx={{ bgcolor: "blue", width: 48, height: 48, fontSize: 20 }}>
          A
        </Avatar>
        <Typography variant="h6" fontWeight="bold">
          Admin <Typography component="span">– All Users</Typography>
        </Typography>
      </Box>

      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <CircularProgress />
        </Box>
      ) : (
        <TableView data={data} currentPage={page} pageSize={pageSize} onPageLoad={fetchUserDetails} onPageChange={(page, pageSize) => fetchUserDetails(page, pageSize)}/>
      )}

      <Snackbar
        style={{ top: "80px" }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snackData.show}
        autoHideDuration={3000}
        onClose={() => setSnackData({ show: false })}
      >
        <Alert
          onClose={() => setSnackData({ show: false })}
          severity={snackData.type}
        >
          {snackData.message}
        </Alert>
      </Snackbar>
    </>
  );
}
